(function(){
  'use strict';

  const state={
    color:null,
    size:null,
    variants:[],
    colorIndex:0,
    sizeIndex:1,
    initialColor:null,
    initialSize:null
  };

  const $=(s,c=document)=>c.querySelector(s);
  const $$=(s,c=document)=>Array.from(c.querySelectorAll(s));

  function money(cents){
    return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format((Number(cents)||0)/100);
  }

  function installment(cents){
    return Math.round((Number(cents)||0)/5);
  }

  function scrollToId(id){
    const el=document.getElementById(id);
    if(!el)return;
    const h=$('.os-header')?.getBoundingClientRect().height||60;
    window.scrollTo({top:el.getBoundingClientRect().top+window.scrollY-h-12,behavior:'smooth'});
  }

  function matches(variant,color,size){
    if(!variant)return false;
    if(color!=null && variant.options?.[state.colorIndex]!==color)return false;
    if(size!=null && variant.options?.[state.sizeIndex]!==size)return false;
    return true;
  }

  function exactVariant(){
    if(!state.size)return null;
    return state.variants.find(v=>matches(v,state.color,state.size))||null;
  }

  function currentDisplayVariant(){
    const exact=exactVariant();
    if(exact)return exact;
    return state.variants.find(v=>matches(v,state.color,null)&&v.available)
      || state.variants.find(v=>matches(v,state.color,null))
      || state.variants.find(v=>v.available)
      || state.variants[0]
      || null;
  }

  function updatePrices(variant){
    if(!variant)return;
    const pay5=money(installment(variant.price));
    const cash=money(variant.price);
    $$('[data-os-installment-price]').forEach(el=>el.innerHTML=`5x de ${pay5} <span>sem juros</span>`);
    $$('[data-os-cash-price]').forEach(el=>el.textContent=`ou ${cash} à vista`);
    $$('[data-os-sticky-installment]').forEach(el=>el.textContent=`5x de ${pay5} sem juros`);
    $$('[data-os-sticky-cash]').forEach(el=>el.textContent=`ou ${cash} à vista`);
    $$('[data-os-final-installment]').forEach(el=>el.innerHTML=`5x de ${pay5} <span>sem juros</span>`);
    $$('[data-os-final-cash]').forEach(el=>el.textContent=`ou ${cash} à vista`);
  }

  function updateAvailability(){
    $$('[data-os-color]').forEach(btn=>{
      const value=btn.dataset.osColor;
      const available=state.variants.some(v=>matches(v,value,null)&&v.available);
      btn.disabled=!available;
      btn.setAttribute('aria-disabled',available?'false':'true');
    });

    $$('[data-os-size]').forEach(btn=>{
      const value=btn.dataset.osSize;
      const available=state.variants.some(v=>matches(v,state.color,value)&&v.available);
      btn.disabled=!available;
      btn.setAttribute('aria-disabled',available?'false':'true');
      if(!available && state.size===value)state.size=null;
    });
  }

  function updateVariantInput(variant){
    if(!variant)return;
    $$('[data-os-variant-input]').forEach(input=>input.value=variant.id);
  }

  function activateMedia(variant){
    if(!variant?.featuredMediaUrl)return;
    const group=$(`[data-gallery-color="${CSS.escape(state.color||'')}"]`);
    if(!group)return;
    const main=$('[data-main-image]',group);
    if(main){
      main.src=variant.featuredMediaUrl;
      main.dataset.mainMediaId=variant.featuredMediaId||'';
    }
    if(variant.featuredMediaId){
      const thumb=$(`[data-media-id="${variant.featuredMediaId}"]`,group);
      if(thumb){
        const index=Number(thumb.dataset.imageIndex||0);
        $$('.os-thumb,.os-mobile-thumb',group).forEach(x=>x.classList.remove('is-active'));
        $$(`[data-image-index="${index}"]`,group).forEach(x=>x.classList.add('is-active'));
        $$('.os-dot',group).forEach((d,i)=>d.classList.toggle('is-active',i===index));
      }
    }
    $$('[data-os-sticky-image]').forEach(img=>img.src=variant.featuredMediaUrl);
  }

  function updateGallery(reset){
    $$('[data-gallery-color]').forEach(el=>{el.hidden=el.dataset.galleryColor!==state.color;});
    const group=$(`[data-gallery-color="${CSS.escape(state.color||'')}"]`);
    if(!group)return;
    if(reset){
      const first=$('[data-image-src]',group);
      const main=$('[data-main-image]',group);
      if(main&&first){main.src=first.dataset.imageSrc;main.alt=first.dataset.imageAlt||'';main.dataset.mainMediaId=first.dataset.mediaId||'';}
      $$('.os-thumb,.os-mobile-thumb',group).forEach((b,i)=>b.classList.toggle('is-active',i===0));
      $$('.os-dot',group).forEach((d,i)=>d.classList.toggle('is-active',i===0));
      const track=$('.os-mobile-track',group);
      if(track)track.scrollTo({left:0,behavior:'auto'});
    }
  }

  function publish(options={}){
    updateAvailability();
    document.documentElement.dataset.osColor=state.color||'';
    document.documentElement.dataset.osSize=state.size||'';
    $$('[data-os-color-label]').forEach(el=>el.textContent=state.color||'');
    $$('[data-os-color]').forEach(b=>b.classList.toggle('is-active',b.dataset.osColor===state.color));
    $$('[data-os-size]').forEach(b=>b.classList.toggle('is-active',b.dataset.osSize===state.size));
    if(options.resetGallery)updateGallery(true);
    else updateGallery(false);
    const variant=currentDisplayVariant();
    updateVariantInput(variant);
    updatePrices(variant);
    if(state.size)activateMedia(exactVariant()||variant);
    clearErrors();
  }

  async function addToCart(button){
    if(!state.size){
      scrollToId('seletor-tamanho');
      showError('Escolha o tamanho antes de adicionar ao carrinho.');
      return;
    }
    const variant=exactVariant();
    if(!variant||!variant.available){
      showError('Essa combinação está indisponível no momento.');
      return;
    }
    if(button){button.disabled=true;button.setAttribute('aria-busy','true');}
    clearErrors();
    try{
      const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      const r=await fetch(root+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(variant.id),quantity:1}]})
      });
      if(!r.ok){
        const j=await r.json().catch(()=>({}));
        throw new Error(j.description||'Não foi possível adicionar ao carrinho.');
      }
      window.location.href=root+'checkout';
    }catch(e){
      showError(e.message||'Não foi possível adicionar ao carrinho.');
    }finally{
      if(button){button.disabled=false;button.removeAttribute('aria-busy');}
    }
  }

  function showError(msg){
    $$('.os-error').forEach(el=>{el.textContent=msg;el.classList.add('is-visible');});
  }

  function clearErrors(){
    $$('.os-error').forEach(el=>{el.textContent='';el.classList.remove('is-visible');});
  }

  function bindGallery(){
    $$('[data-gallery-color]').forEach(group=>{
      $$('.os-thumb,.os-mobile-thumb',group).forEach(btn=>btn.addEventListener('click',()=>{
        const index=Number(btn.dataset.imageIndex||0);
        const main=$('[data-main-image]',group);
        if(main){
          main.src=btn.dataset.imageSrc;
          main.alt=btn.dataset.imageAlt||'';
          main.dataset.mainMediaId=btn.dataset.mediaId||'';
        }
        $$('.os-thumb,.os-mobile-thumb',group).forEach(x=>x.classList.remove('is-active'));
        $$(`[data-image-index="${index}"]`,group).forEach(x=>x.classList.add('is-active'));
        $$('.os-dot',group).forEach((d,i)=>d.classList.toggle('is-active',i===index));
        const track=$('.os-mobile-track',group);
        if(track){
          const slide=track.children[index];
          if(slide)track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:'smooth'});
        }
      }));

      const track=$('.os-mobile-track',group);
      if(track)track.addEventListener('scroll',()=>{
        const children=Array.from(track.children);
        const center=track.scrollLeft+track.clientWidth/2;
        let best=0,dist=Infinity;
        children.forEach((child,i)=>{
          const childCenter=child.offsetLeft-track.offsetLeft+child.clientWidth/2;
          const d=Math.abs(center-childCenter);
          if(d<dist){dist=d;best=i;}
        });
        $$('.os-dot',group).forEach((d,i)=>d.classList.toggle('is-active',i===best));
        $$('.os-mobile-thumb',group).forEach((d,i)=>d.classList.toggle('is-active',i===best));
      },{passive:true});
    });
  }

  function initProduct(){
    const data=$('[data-os-product-data]');
    if(!data)return;
    try{
      const json=JSON.parse(data.textContent);
      state.variants=json.variants||[];
      state.colorIndex=Number(json.colorIndex||0);
      state.sizeIndex=Number(json.sizeIndex||1);
      state.initialColor=json.initialColor||state.variants[0]?.options?.[state.colorIndex]||null;
      state.initialSize=json.initialSize||state.variants[0]?.options?.[state.sizeIndex]||null;
      state.color=state.initialColor;
      state.size=null;
    }catch(e){return;}

    $$('[data-os-color]').forEach(btn=>btn.addEventListener('click',()=>{
      if(btn.disabled)return;
      state.color=btn.dataset.osColor;
      if(state.size){
        const stillAvailable=state.variants.some(v=>matches(v,state.color,state.size)&&v.available);
        if(!stillAvailable)state.size=null;
      }
      publish({resetGallery:true});
    }));

    $$('[data-os-size]').forEach(btn=>btn.addEventListener('click',()=>{
      if(btn.disabled)return;
      state.size=state.size===btn.dataset.osSize?null:btn.dataset.osSize;
      publish();
    }));

    const nativeForm=$('#os-native-product-form');
    if(nativeForm)nativeForm.addEventListener('submit',e=>{
      e.preventDefault();
      addToCart($('[data-os-buy]',nativeForm));
    });

    $$('[data-os-buy]').forEach(btn=>{
      if(btn.closest('#os-native-product-form'))return;
      btn.addEventListener('click',e=>{e.preventDefault();addToCart(btn);});
    });

    $$('[data-scroll-to]').forEach(btn=>btn.addEventListener('click',e=>{
      e.preventDefault();
      scrollToId(btn.dataset.scrollTo);
    }));

    bindGallery();
    publish({resetGallery:true});
  }

  function initCalc(){
    const btn=$('[data-size-calc]');
    if(!btn)return;
    btn.addEventListener('click',()=>{
      const w=parseInt($('#os-waist')?.value,10),h=parseInt($('#os-hip')?.value,10),out=$('[data-size-result]');
      if(!out)return;
      if(Number.isNaN(w)||Number.isNaN(h)){out.textContent='Preencha os dois campos para descobrir seu tamanho.';return;}
      const rows=[['PP',64,73,85,100],['P',74,83,95,115],['M',84,93,111,120],['G',94,103,120,130]];
      const exact=rows.find(r=>w>=r[1]&&w<=r[2]&&h>=r[3]&&h<=r[4]);
      if(exact){out.textContent='Seu tamanho ideal é o '+exact[0]+'.';return;}
      const bw=rows.find(r=>w>=r[1]&&w<=r[2]),bh=rows.find(r=>h>=r[3]&&h<=r[4]);
      if(bw&&bh){out.textContent='Você está entre os tamanhos '+bw[0]+' e '+bh[0]+'. Recomendamos o '+bh[0]+' para ajuste no quadril, ou escolha o maior para mais conforto.';return;}
      if(bw){out.textContent='Seu tamanho indicado é o '+bw[0]+'.';return;}
      if(bh){out.textContent='Seu tamanho indicado é o '+bh[0]+'.';return;}
      out.textContent=(w<64||h<85)?'Seu tamanho indicado é o PP.':'Seu tamanho indicado é o G.';
    });
  }

  function initModal(){
    const modal=$('#os-measure-modal');
    if(!modal)return;
    $$('[data-open-measure]').forEach(btn=>btn.addEventListener('click',()=>modal.classList.add('is-open')));
    $$('[data-close-measure]').forEach(btn=>btn.addEventListener('click',()=>modal.classList.remove('is-open')));
    modal.addEventListener('click',e=>{if(e.target===modal)modal.classList.remove('is-open');});
    window.addEventListener('keydown',e=>{if(e.key==='Escape')modal.classList.remove('is-open');});
  }

  function initFaq(){
    $$('.os-faq-q').forEach(btn=>btn.addEventListener('click',()=>{
      const item=btn.closest('.os-faq-item');
      if(!item)return;
      item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',item.classList.contains('is-open')?'true':'false');
    }));
  }

  function initVideos(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const obs=new IntersectionObserver(entries=>entries.forEach(entry=>{
      const video=entry.target;
      if(entry.isIntersecting)video.play().catch(()=>{});else video.pause();
    }),{threshold:.4});
    $$('.os-reel video').forEach(video=>obs.observe(video));
  }

  function initSticky(){
    const bar=$('.os-sticky-buy'),product=$('#produto'),cta=$('#final-cta');
    if(!bar||!product)return;
    const update=()=>{
      const show=product.getBoundingClientRect().bottom<0&&(!cta||cta.getBoundingClientRect().top>window.innerHeight*.4);
      bar.classList.toggle('is-visible',show);
    };
    update();
    addEventListener('scroll',update,{passive:true});
    addEventListener('resize',update);
  }

  document.addEventListener('DOMContentLoaded',()=>{
    const root=document.documentElement;
    root.style.setProperty('--os-brand',getComputedStyle(root).getPropertyValue('--os-brand').trim()||'#e60012');
    initProduct();
    initCalc();
    initModal();
    initFaq();
    initVideos();
    initSticky();
  });
})();
